export class IntervalManager {

  private intervals: NodeJS.Timeout[] = [];

  setInterval(
      cb: () => (any | Promise<any>),
      intervalMs: number,
  ): ReturnType<typeof setInterval> {

    const interval = setInterval(async () => {
      try {
        await cb();
      } catch (error) {
        console.error('Error in interval callback:', error);
      }
    }, intervalMs);

    this.intervals.push(interval);
    return interval as ReturnType<typeof setInterval>;
  }

  clearIntervals() {
    for (const interval of this.intervals) {
      clearInterval(interval);
    }
    this.intervals = [];
  }

}
